import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { useSettingsSelector } from '@/utils'

type ProjectParamsProps = {
  workspaceId: string
  projectId: string
}

export function useProject() {
  const { workspaceId, projectId } = useParams<ProjectParamsProps>()

  const defaultProject = useSettingsSelector(
    settings => settings.defaultProject,
  )

  return useMemo(() => {
    if (!workspaceId || !projectId) {
      return {
        workspaceId: defaultProject?.workspaceId || null,
        projectId: defaultProject?.projectId || null,
      }
    }
    return { workspaceId: Number(workspaceId), projectId: Number(projectId) }
  }, [workspaceId, projectId, defaultProject])
}
